import { useNavigate } from "react-router-dom";
import { useTeamMembers } from "@/lib/teamRecordQueries";

/**
 * Clients Restructure — Team 360 -> Members. Each member links out to
 * their OWN Client 360 — editing an individual's Journey/assignments/
 * private files always happens there, never here.
 */
export default function MembersTab({ workspaceId }) {
  const navigate = useNavigate();
  const { data, isPending, isError } = useTeamMembers(workspaceId);
  const items = data?.items || [];

  return (
    <div data-testid="team-360-members-tab">
      {isPending ? (
        <p className="text-sm text-ink-soft" data-testid="team-members-loading">Loading members…</p>
      ) : isError ? (
        <p className="text-sm text-red-600" data-testid="team-members-error">Couldn't load team members.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="team-members-list">
          {items.map((m) => (
            <div key={m.member_id} className="border border-ink/10 rounded-lg p-4 bg-white/50 flex items-center justify-between gap-3" data-testid={`team-member-card-${m.member_id}`}>
              <div>
                <p className="text-sm font-medium text-ink">{m.name}</p>
                {m.email && <p className="text-xs text-ink-soft">{m.email}</p>}
              </div>
              <button
                onClick={() => navigate(`/rehearsal-room/coach/w/${workspaceId}/client/${m.member_id}/overview`)}
                className="text-sm font-medium border border-ink/15 px-3 py-1.5 rounded-full text-ink hover:bg-ink/5 transition-colors shrink-0"
                data-testid={`team-member-view-client-360-${m.member_id}`}
              >
                View Client 360
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
